// features/licenses/actions.ts
import type { LicensesState, LicenseRow } from "./types";
import type { Action } from "./reducer";
import { fetchLicenses } from "./service";
import { makeRow } from "./transform";
import api from "src/services/api";

export interface LicensesActions {
  load: (cb?:Function) => Promise<void>;
  setSelectedRow: (id: number) => void;
  selectRow: (row: LicenseRow | null) => void;
  clearSelection: () => void;
  setManagementDrawerOpen: (open: boolean) => void;
  cancelMainLicense: (id: number) => Promise<void>;
  
}

export function createActions(
  dispatch: React.Dispatch<Action>,
  getState: () => LicensesState
): LicensesActions {
  return {
    load: async (cb?:Function) => {
      dispatch({ type: "LOAD_STARTED" });
      try {
        const list = await fetchLicenses();
        const rows = list.map((p) => makeRow(p));
        dispatch({ type: "LOAD_SUCCEEDED", payload: rows });

        if(cb) cb();

      } catch (e: any) {
        console.error(e);
        dispatch({
          type: "LOAD_FAILED",
          error: e?.message || "Lisanslar alınamadı",
        });
      }
    },


    cancelMainLicense: async (id: number) => {

      dispatch({ type: "CANCEL_MAIN_LICENSE_STARTED" });
      try {
        await api.get("/licenses/cancel/" + id);
        await new Promise((resolve) => setTimeout(resolve, 1000));
        dispatch({ type: "CANCEL_MAIN_LICENSE_SUCCEEDED", id });
      } catch (e: any) {
        console.error(e);
        dispatch({
          type: "CANCEL_MAIN_LICENSE_FAILED",
          error: e?.message || "Lisans iptali yapılamadı",
        });
      }



    },


    setSelectedRow: (id: number) => dispatch({ type: "SELECT_SET", id }),
    selectRow: (row: LicenseRow | null) => dispatch({ type: "SELECT_SET", row }),
    clearSelection: () => dispatch({ type: "SELECT_SET", row: null }),
    setManagementDrawerOpen: (open: boolean) => dispatch({ type: "MANAGEMENT_DRAWER_OPEN_SET", open }),
  };
}
